import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'mat-vert-grid',
    template: `<div fxFlex class="mat-elevation-z8"></div>
       <div *ngIf="title" class="title">{{title}}</div>
       <div class="border-top">
          <div class="border-bottom" fxFlex fxLayout="column" *ngFor="let tile of titles; let col of index">
             <div class="caption">{{tile.text}}</div>
             <div fxFlex class="value">{{getValue(tile.field)}}</div>
          </div>
        </div>`,
    styles: [`
    .border-bottom {
        border-bottom: 1px solid rgba(28, 110, 164, 0.32);
    }
    .border-top {
        border-top: 1px solid rgba(28, 110, 164, 0.32);
    }
    .caption {
        font-size: 0.8em;
        font-weight: 500;
    }
    .value{
        font-size: 0.9em;
    }
    `]
})
export class MatVertGrid implements OnInit {

    fDataSource:any;
    @Input()
    titles:any[]=[];

    constructor() { }

    ngOnInit(): void { }
    @Input()
    get dataSource(){
        return this.fDataSource;
    }
    set dataSource(x){
        console.log(x);
        if (this.titles.length==0){
            for (var key in x) {
                if (key != "index") {
                    this.addTitle(key,key);
                }
            }
        }
        this.fDataSource = x;
    }

    @Input()
    title:string;
    @Input()
    get columns(){
        return this.titles;
    }
    set columns(x){
        this.titles = x;
    }
    @Input()
    get values(){
        return this.dataSource;
    }

    set values(x){
        this.dataSource = x;
    }



    addTitle(field:string, text:string){
        this.titles.push({"field":field,"text":text});
    }

   getValue(field){
      let v = this.dataSource[field];
      if (v){
      if (v.constructor.name=="Timestamp"){
          v = this.dataSource[field].toDate();
      } 
      if (v.constructor.name == "Date"){
        var datePipe = new DatePipe("en-US");
        v = datePipe.transform(v, 'dd/MM/yyyy hh:mm');
      }
    }
      return v;
   }

}
